import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vModelText as _vModelText, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_4 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_5 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  href: "mailto:hello@playincluded.com",
  class: "underline"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["onSubmit"]
const _hoisted_15 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_16 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_17 = { class: "capitalize" }
const _hoisted_18 = { class: "capitalize" }
const _hoisted_19 = { class: "capitalize" }
const _hoisted_20 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "mb-2 italic"
}
const _hoisted_23 = { class: "hidden w-full table-auto md:table" }
const _hoisted_24 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_25 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_26 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_27 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_28 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}, null, -1)
const _hoisted_30 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_31 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_32 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_33 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_34 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "block md:hidden" }
const _hoisted_37 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_38 = { class: "mx-1 font-bold" }
const _hoisted_39 = { class: "w-full px-2 py-3" }
const _hoisted_40 = { class: "mx-1 font-bold" }
const _hoisted_41 = { class: "w-full px-2 py-3" }
const _hoisted_42 = { class: "mx-1 font-bold" }
const _hoisted_43 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_44 = { class: "mx-1 font-bold" }
const _hoisted_45 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "space-y-2.5" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = ["placeholder"]
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = ["placeholder"]
const _hoisted_54 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "flex flex-wrap space-y-2" }
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = { class: "text-sm text-gray-900" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://goo.gl/maps/8joDRwk36ENmxito9",
  target: "_blank"
}, "https://goo.gl/maps/8joDRwk36ENmxito9", -1)
const _hoisted_60 = { class: "flex" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "inset-y-0 left-0 flex items-center px-4 bg-gray-200 border-l border-gray-400 rounded-l border-y" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "https://")
], -1)
const _hoisted_62 = ["value"]
const _hoisted_63 = ["value"]
const _hoisted_64 = { class: "" }
const _hoisted_65 = { class: "flex items-center" }
const _hoisted_66 = { class: "capitalize" }
const _hoisted_67 = ["currency"]
const _hoisted_68 = { class: "block" }
const _hoisted_69 = {
  class: "lowercase",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "mt-4" }
const _hoisted_72 = { class: "mt-4" }
const _hoisted_73 = { class: "flex space-x-4" }
const _hoisted_74 = { class: "block space-x-2" }
const _hoisted_75 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_76 = { class: "block space-x-2" }
const _hoisted_77 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_78 = {
  key: 0,
  class: "block space-x-2"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "inline-block pl-[0.15rem]" }, " Tax-free ", -1)
const _hoisted_80 = { class: "flex" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "inset-y-0 left-0 flex items-center px-4 bg-gray-200 border-l border-gray-400 rounded-l border-y" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "https://")
], -1)
const _hoisted_82 = ["placeholder"]
const _hoisted_83 = { class: "px-4 py-4 bg-gray-100 border-t border-gray-400" }
const _hoisted_84 = { class: "flex flex-wrap gap-4 py-6" }

import { computed, ref, watch } from "vue";
import { storeToRefs } from "pinia";

import AvailableCountriesModal from "@/components/modals/AvailableCountriesModal.vue";
import AddPresentersInput from "@/components/events/AddPresentersInput.vue";
import StoryblockDescription from "@/components/StoryblockDescription.vue";
// import CurrencyInput from "@/components/events/CurrencyInput.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import PriceDisplay from "@/components/PriceDisplay.vue";
import TagSelector from "@/components/TagSelector.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import AlertCard from "@/components/AlertCard.vue";

import api from "@/api/api";
import { CreateEventRequest, Template, User } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";
import { formatDate, getFutureTimezone } from "@/utils/dates";
import { useI18n } from "vue-i18n";
import { userHasRole } from "@/utils/roles";
import { deserializeSlug } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewEvent',
  async setup(__props) {

let __temp: any, __restore: any

const { t: $t } = useI18n();

const globalStore = useGlobalStore();
const { currentLanguage } = storeToRefs(globalStore);
const { user, short_timezone, timezone, timezone_offset, userIsAdmin } = storeToRefs(useUserStore());

const datepicker = ref(null);
const publish_at_datepicker = ref(null);
const register_by_datepicker = ref(null);

const isDraftSaving = ref(false);
const isReviewSaving = ref(false);
const isAvailableCountriesModalOpen = ref(false);

const asyncEventDelivery = ["e-learning"];
const syncEventDelivery = ["live-webinar", "in-person"];
const allowedTrainerLevels = ["Advanced Facilitator", "Level 03 Specialist", "Level 04a Trainer"];

const story = ref({} as any);
const languages = ref([] as string[]);
const dates = ref([
  {
    end_time: "",
    event_date: "",
    start_time: "",
    timezone: timezone.value,
    short_timezone: short_timezone.value,
    timezone_offset: timezone_offset.value,
  },
] as { event_date: string; start_time: string; end_time: string; timezone: string; short_timezone: string; timezone_offset: number }[]);
const users = ref([] as User[]);

const userSelectedTemplate = ref(false);
const selectedTemplate = ref({} as Template);
const selectedTemplatePricing = ref({} as any);

const publish_at = ref();
const publish_at_date = ref();
const publish_at_time = ref();

const event = ref({
  owner_id: "",
  template_id: 0,
  name: "",
  dates: dates.value,
  address_line_one: "",
  address_line_two: "",
  city: "",
  postcode: "",
  country: "",
  status: "draft",
  visibility: false,
  meeting_link: "",
  payment_link: "",
  payment_gateway: "",
  max_attendees: null,
  min_attendees: null,
  countries: [] as string[],
  register_by: "",
  publish_at: "",
  language: currentLanguage.value?.name ? currentLanguage.value?.name : "",
  enable_waitlist: false,
  presenters: [],
  tags: [],
  trainer_pricing: 0,
  trainer_currency: "gbp",
  trainer_tax_status: "inc",
  maps_link: "",
  discount_code: "",
  host_country: "",
});

const templates = ref([] as Template[]);

const isAsyncEvent = computed(() => {
  if (selectedTemplate.value.level === "Specialist (Level 3)") {
    return true;
  }

  if (asyncEventDelivery.includes(selectedTemplate.value.delivery)) {
    return true;
  }

  return false;
});

function setDate(date: Date, ref: string) {
  if (!date) return;

  event.value[ref] = formatDate(date);

  if (ref === "publish_at") {
    publish_at_datepicker.value.closeMenu();
  }

  if (ref === "register_by") {
    register_by_datepicker.value.closeMenu();
  }
}

function setScheduleDate(i: number, date: Date) {
  if (!date) return;

  dates.value[i].event_date = formatDate(date);

  const futureTimezone = getFutureTimezone(dates.value[i].event_date, timezone.value);

  dates.value[i].timezone = futureTimezone.timezone;
  dates.value[i].short_timezone = futureTimezone.short_timezone;

  datepicker.value[i].closeMenu();
}

async function setEventTemplate(e: any) {
  const template = templates.value.find(temp => temp.id == e.target.value)!;

  selectedTemplate.value = template;
  event.value.template_id = template.id;

  selectedTemplatePricing.value = selectedTemplate.value.countries.find(country => country.country === user.value.country);

  if (!userIsAdmin.value && selectedTemplatePricing.value) {
    event.value.trainer_pricing = selectedTemplatePricing.value.pricing / 100;
    event.value.trainer_currency = selectedTemplatePricing.value.currency.toUpperCase();
    event.value.trainer_tax_status = "inc";
  }

  story.value = await (await api.templates.getTemplateStory(selectedTemplate.value.id, selectedTemplate.value.storyblok_slug)).data.story;
}

function setEventTags(e: number[]) {
  event.value.tags = e;
}

function setAvailableCountries(countries: string[]) {
  event.value.countries = countries;
  isAvailableCountriesModalOpen.value = false;
}

function addEventDate() {
  dates?.value.push({
    event_date: "",
    start_time: "",
    end_time: "",
    timezone: timezone.value,
    short_timezone: short_timezone.value,
    timezone_offset: timezone_offset.value,
  });
}

function removeEventDate(index: number) {
  if (index === 0) {
    return;
  }

  dates.value.splice(index, 1);
}

async function saveEvent(e: any) {
  if (isDraftSaving.value || isReviewSaving.value) {
    return;
  }

  if (!event.value.countries.length) {
    globalStore.toast("ERROR", $t("please-select-a-country-0"));
    return;
  }

  if (userHasRole(user.value.roles, ["l4a-trainer", "trainer-organisation"])) {
    if (!event.value.payment_gateway) {
      globalStore.toast("ERROR", $t("please-enter-a-payment-gateway"));
      return;
    }

    if (!event.value.payment_link) {
      globalStore.toast("ERROR", $t("please-enter-a-payment-link"));
      return;
    }
  }

  event.value.status = e.submitter!.id;

  if (event.value.status === "draft") {
    isDraftSaving.value = true;
  } else {
    isReviewSaving.value = true;
  }

  try {
    const data: CreateEventRequest = {
      name: selectedTemplate.value.name,
      template_id: selectedTemplate.value.id,
      type: selectedTemplate.value.type,
      meeting_link: event.value.meeting_link,
      payment_link: event.value.payment_link,
      payment_gateway: event.value.payment_gateway,
      address_line_one: event.value.address_line_one,
      address_line_two: event.value.address_line_two,
      city: event.value.city,
      postcode: event.value.postcode,
      owner_id: event.value.owner_id,
      visibility: event.value.visibility,
      status: event.value.status,
      max_attendees: event.value.max_attendees,
      min_attendees: event.value.min_attendees,
      countries: event.value.countries,
      language: event.value.language,
      publish_at: event.value.publish_at,
      register_by: event.value.register_by,
      enable_waitlist: event.value.enable_waitlist,
      tags: event.value.tags,
      presenters: event.value.presenters,
      trainer_pricing: event.value.trainer_pricing,
      trainer_currency: event.value.trainer_currency,
      trainer_tax_status: event.value.trainer_tax_status,
      maps_link: event.value.maps_link,
      discount_code: event.value.discount_code,
      host_country: event.value.host_country,
    };

    if (dates.value[0].event_date !== "") {
      data["dates"] = dates.value;
    }

    const response = await api.events.createEvent(data);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", $t("event-created"));
      return (window.location.href = `/dashboard/courses/events/${response.data.event.id}`);
    } else {
      throw Error();
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-creating-event"));
    isDraftSaving.value = false;
    isReviewSaving.value = false;
  }
}

const checkCurrency = (kevent: KeyboardEvent) => {
  const allowedKeys = ["Delete", "Backspace", ".", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "ArrowLeft", "ArrowRight"];
  if (!allowedKeys.includes(kevent.key)) {
    kevent.preventDefault();
  }

  // restrict to 2 decimal places
  if (event.value.trainer_pricing.toString().indexOf(".") > -1 && event.value.trainer_pricing.toString().split(".")[1].length > 1) {
    const allowedKeysDelete = ["Delete", "Backspace", "ArrowLeft", "ArrowRight"];
    if (!allowedKeysDelete.includes(kevent.key)) {
      kevent.preventDefault();
    }
  }
};

watch(publish_at_date, () => {
  publish_at.value = new Date(publish_at_date.value);
});

watch(publish_at_time, () => {
  publish_at.value = new Date(publish_at.value).setUTCHours(publish_at_time.value.hours);
});

watch(
  () => event.value.trainer_pricing,
  () => {
    console.log(event.value.trainer_pricing);
  }
);

languages.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listLanguages())),
  __temp = await __temp,
  __restore(),
  __temp
)).languages;
templates.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listTemplates("all"))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.templates;
users.value = (
  (
  ([__temp,__restore] = _withAsyncContext(() => api.users.listUsers({
    page: "all",
    roles: ["l4a-trainer", "trainer-organisation", "admin", "courses-admin"],
  }))),
  __temp = await __temp,
  __restore(),
  __temp
)
).data.users;

if (templates.value.length) {
  event.value.template_id = templates.value[0].id;
}

event.value.owner_id = user.value.id;

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (selectedTemplate.value.id)
      ? (_openBlock(), _createBlock(AvailableCountriesModal, {
          key: 0,
          isOpen: isAvailableCountriesModalOpen.value,
          template: selectedTemplate.value,
          countries: event.value.countries,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isAvailableCountriesModalOpen.value = false)),
          onSelect: setAvailableCountries
        }, null, 8, ["isOpen", "template", "countries"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref($t)('add-a-new-event')
      }, null, 8, ["title"])
    ]),
    (!userSelectedTemplate.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (templates.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(AlertCard, {
                  type: "info",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_unref($t)("to-get-started-please-select-a-course-template")), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref($t)("event-details")), 1),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('course-template')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
                          default: _withCtx(() => [
                            _createElementVNode("select", {
                              id: "subscription",
                              class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                              onChange: setEventTemplate
                            }, [
                              _createElementVNode("option", _hoisted_5, _toDisplayString(_unref($t)("please-select")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "capitalize",
                                  value: template.id,
                                  key: template.id
                                }, _toDisplayString(template.name), 9, _hoisted_6))
                              }), 128))
                            ], 32)
                          ]),
                          _: 1
                        }),
                        _createVNode(RoleGuard, { roles: ['trainer-organisation', 'l4a-trainer'] }, {
                          default: _withCtx(() => [
                            _createElementVNode("select", {
                              id: "subscription",
                              class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                              onChange: setEventTemplate
                            }, [
                              _createElementVNode("option", _hoisted_7, _toDisplayString(_unref($t)("please-select")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value.filter(temp => allowedTrainerLevels.includes(temp.level)), (template) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "capitalize",
                                  value: template.id,
                                  key: template.id
                                }, _toDisplayString(template.name), 9, _hoisted_8))
                              }), 128))
                            ], 32)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('course-level')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(selectedTemplate.value.level), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('course-type')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(deserializeSlug)(selectedTemplate.value.type ?? "")), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('delivery-method')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(deserializeSlug)(selectedTemplate.value.delivery)), 1)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                (selectedTemplate.value.id)
                  ? (_openBlock(), _createBlock(DefaultButton, {
                      key: 0,
                      id: "draft",
                      type: "primary",
                      onAction: _cache[1] || (_cache[1] = ($event: any) => (userSelectedTemplate.value = true)),
                      class: "mt-6"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("use-this-template")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (story.value.id)
                  ? (_openBlock(), _createBlock(StoryblockDescription, {
                      key: 1,
                      class: "mt-6",
                      story: story.value
                    }, null, 8, ["story"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(AlertCard, {
                  type: "warning",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("there-are-currently-no-templates-available-to-you-please-contact")) + " ", 1),
                    _createElementVNode("a", _hoisted_12, _toDisplayString(_unref($t)("play-included")), 1),
                    _createTextVNode(" " + _toDisplayString(_unref($t)("for-more-information")) + ".", 1)
                  ]),
                  _: 1
                })
              ]))
        ]))
      : _createCommentVNode("", true),
    (userSelectedTemplate.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("form", {
            class: "mt-8",
            onSubmit: _withModifiers(saveEvent, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref($t)("event-details")), 1),
              _createVNode(ListRowItem, {
                title: _unref($t)('course-template'),
                class: "bg-play-gray"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(selectedTemplate.value.name), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _unref($t)('course-level'),
                class: "bg-play-gray"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(selectedTemplate.value.level), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _unref($t)('course-type'),
                class: "bg-play-gray"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(deserializeSlug)(selectedTemplate.value.type)), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _unref($t)('delivery-method'),
                class: "bg-play-gray"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(deserializeSlug)(selectedTemplate.value.delivery)), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              (selectedTemplate.value.delivery === 'live-webinar' || selectedTemplate.value.delivery === 'in-person')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 0,
                    title: _unref($t)('host-country')
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("select", {
                        id: "subscription",
                        class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((event.value.host_country) = $event)),
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_20, _toDisplayString(_unref($t)("please-select")), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplate.value.countries, (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            class: "capitalize",
                            value: country.country,
                            key: country.country
                          }, _toDisplayString(country.country), 9, _hoisted_21))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, event.value.host_country]
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(ListRowItem, {
                title: _unref($t)('available-countries')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.countries, (country) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "capitalize",
                        key: country
                      }, _toDisplayString(country), 1))
                    }), 128))
                  ]),
                  _createVNode(DefaultButton, {
                    type: "primary",
                    class: "mt-4",
                    onAction: _cache[3] || (_cache[3] = ($event: any) => (isAvailableCountriesModalOpen.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)("select-available-countries")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"]),
              (!_unref(isAsyncEvent))
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 1,
                    title: _unref($t)('date-and-time'),
                    flex: false
                  }, {
                    default: _withCtx(() => [
                      (selectedTemplate.value.delivery === 'webinar')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_unref($t)("optional")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("table", _hoisted_23, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_24, [
                            _createElementVNode("th", _hoisted_25, _toDisplayString(_unref($t)("date")), 1),
                            _createElementVNode("th", _hoisted_26, _toDisplayString(_unref($t)("start-time")), 1),
                            _createElementVNode("th", _hoisted_27, _toDisplayString(_unref($t)("end-time")), 1),
                            _createElementVNode("th", _hoisted_28, _toDisplayString(_unref($t)("timezone")), 1),
                            _hoisted_29
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              class: "border-b border-gray-400 divide-x-2 divide-gray-400 bg-play-gray",
                              key: index
                            }, [
                              _createElementVNode("td", _hoisted_30, [
                                _createVNode(_component_DatePicker, {
                                  ref_for: true,
                                  ref_key: "datepicker",
                                  ref: datepicker,
                                  modelValue: date.event_date,
                                  "onUpdate:modelValue": ($event: any) => ((date.event_date) = $event),
                                  onInternalModelChange: e => setScheduleDate(index, e),
                                  required: syncEventDelivery.includes(selectedTemplate.value.delivery),
                                  "enable-time-picker": false,
                                  format: "dd/MMM/yyyy",
                                  "min-date": new Date(),
                                  onCleared: ($event: any) => (removeEventDate(index))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInternalModelChange", "required", "min-date", "onCleared"])
                              ]),
                              _createElementVNode("td", _hoisted_31, [
                                _createVNode(_component_DatePicker, {
                                  required: syncEventDelivery.includes(selectedTemplate.value.delivery),
                                  "time-picker": "",
                                  modelValue: date.start_time,
                                  "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                                  "model-type": "HH:mm"
                                }, null, 8, ["required", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_32, [
                                _createVNode(_component_DatePicker, {
                                  required: syncEventDelivery.includes(selectedTemplate.value.delivery),
                                  "time-picker": "",
                                  modelValue: date.end_time,
                                  "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                                  "model-type": "HH:mm"
                                }, null, 8, ["required", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_33, [
                                _createElementVNode("p", null, _toDisplayString(date.short_timezone), 1)
                              ]),
                              _createElementVNode("td", _hoisted_34, [
                                (index > 0)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "mx-2 underline text-blue",
                                      onClick: _withModifiers(($event: any) => (removeEventDate(index)), ["self"])
                                    }, _toDisplayString(_unref($t)("delete")), 9, _hoisted_35))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex flex-wrap border-b-2 border-gray-300 bg-play-gray",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("label", _hoisted_38, _toDisplayString(_unref($t)("date")), 1),
                              _createVNode(_component_DatePicker, {
                                ref_for: true,
                                ref_key: "datepicker",
                                ref: datepicker,
                                modelValue: date.event_date,
                                "onUpdate:modelValue": ($event: any) => ((date.event_date) = $event),
                                onInternalModelChange: e => setScheduleDate(index, e),
                                "enable-time-picker": false,
                                format: "dd/MMM/yyyy",
                                class: "mt-1",
                                "min-date": new Date(),
                                onCleared: ($event: any) => (removeEventDate(index))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInternalModelChange", "min-date", "onCleared"])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("label", _hoisted_40, _toDisplayString(_unref($t)("start-time")), 1),
                              _createVNode(_component_DatePicker, {
                                "time-picker": "",
                                modelValue: date.start_time,
                                "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                                class: "mt-1",
                                "model-type": "HH:mm"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("label", _hoisted_42, _toDisplayString(_unref($t)("end-time")), 1),
                              _createVNode(_component_DatePicker, {
                                "time-picker": "",
                                modelValue: date.end_time,
                                "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                                class: "mt-1",
                                "model-type": "HH:mm"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("label", _hoisted_44, _toDisplayString(_unref($t)("timezone")), 1),
                              _createElementVNode("p", null, _toDisplayString(date.short_timezone), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("button", {
                                class: "mx-2 underline text-blue",
                                onClick: ($event: any) => (removeEventDate(index))
                              }, _toDisplayString(_unref($t)("delete")), 9, _hoisted_46)
                            ])
                          ]))
                        }), 128))
                      ]),
                      (dates.value.length > 0)
                        ? (_openBlock(), _createBlock(DefaultButton, {
                            key: 1,
                            type: "primary",
                            class: "mt-4",
                            onAction: addEventDate
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($t)("add-another-date")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(ListRowItem, {
                title: _unref($t)('language')
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "subscription",
                    class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((event.value.language) = $event)),
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_47, _toDisplayString(_unref($t)("please-select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "capitalize",
                        value: language,
                        key: language
                      }, _toDisplayString(_unref($t)(language)), 9, _hoisted_48))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, event.value.language]
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              (selectedTemplate.value.delivery === 'in-person')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 2,
                    title: _unref($t)('location')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "address-line-1",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((event.value.address_line_one) = $event)),
                          placeholder: _unref($t)('address-line-1'),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          required: ""
                        }, null, 8, _hoisted_50), [
                          [_vModelText, event.value.address_line_one]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "address-line-two",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((event.value.address_line_two) = $event)),
                          placeholder: _unref($t)('address-line-2'),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                        }, null, 8, _hoisted_51), [
                          [_vModelText, event.value.address_line_two]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "city",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((event.value.city) = $event)),
                          placeholder: _unref($t)('city'),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          required: ""
                        }, null, 8, _hoisted_52), [
                          [_vModelText, event.value.city]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "postcode",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((event.value.postcode) = $event)),
                          placeholder: _unref($t)('postcode'),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          required: ""
                        }, null, 8, _hoisted_53), [
                          [_vModelText, event.value.postcode]
                        ]),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("select", {
                            id: "subscription",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((event.value.country) = $event)),
                            class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                            required: ""
                          }, [
                            _createElementVNode("option", _hoisted_54, _toDisplayString(_unref($t)("please-select-a-country")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplate.value.countries, (country) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "capitalize",
                                value: country.country,
                                key: country.country
                              }, _toDisplayString(country.country), 9, _hoisted_55))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, event.value.country]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "google_maps",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((event.value.maps_link) = $event)),
                            placeholder: _unref($t)('google-maps-optional'),
                            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                          }, null, 8, _hoisted_57), [
                            [_vModelText, event.value.maps_link]
                          ]),
                          _createElementVNode("span", _hoisted_58, [
                            _createTextVNode(_toDisplayString(_unref($t)("please-add-a-direct-link-to-help-the-user-find-the-venue-e-g")) + " ", 1),
                            _hoisted_59
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (selectedTemplate.value.delivery !== 'in-person')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 3,
                    title: _unref($t)('selectedtemplate-delivery-e-learning-e-learning-online-meeting-link', [selectedTemplate.value.delivery === `e-learning` ? `E-learning` : `Online meeting`])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "location",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((event.value.meeting_link) = $event)),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-r",
                          required: ""
                        }, null, 512), [
                          [_vModelText, event.value.meeting_link]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(ListRowItem, {
                title: _unref($t)('organisation'),
                class: "bg-play-gray"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(user).organisation?.name), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'trainer-organisation'] }, {
                default: _withCtx(() => [
                  _createVNode(ListRowItem, {
                    title: _unref($t)('event-owner')
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((event.value.owner_id) = $event)),
                        id: "subscription",
                        onChange: _cache[13] || (_cache[13] = $event => (event.value.trainer_id = $event.target.value)),
                        class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                        required: ""
                      }, [
                        _createElementVNode("option", {
                          value: _unref(user).id,
                          selected: "",
                          disabled: ""
                        }, _toDisplayString(_unref(user).first_name) + " " + _toDisplayString(_unref(user).last_name), 9, _hoisted_62),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: user.id,
                            key: user.id
                          }, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 9, _hoisted_63))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, event.value.owner_id]
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }),
              (users.value && selectedTemplate.value.delivery !== 'e-learning')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 4,
                    title: _unref($t)('presenters'),
                    centerLabel: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AddPresentersInput, {
                        presenters: event.value.presenters,
                        users: users.value,
                        onSelect: _cache[14] || (_cache[14] = $event => event.value.presenters.push($event)),
                        onRemove: _cache[15] || (_cache[15] = $event => event.value.presenters.splice($event, 1))
                      }, null, 8, ["presenters", "users"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(ListRowItem, {
                title: _unref($t)('price'),
                class: "bg-play-gray",
                "center-label": false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
                      default: _withCtx(() => [
                        _createVNode(PriceDisplay, {
                          locale: "en-GB",
                          price: selectedTemplatePricing.value.pricing,
                          currency: selectedTemplatePricing.value.currency,
                          vat: selectedTemplatePricing.value.vat
                        }, null, 8, ["price", "currency", "vat"])
                      ]),
                      _: 1
                    }),
                    _createVNode(RoleGuard, { roles: ['l4a-trainer', 'trainer-organisation'] }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_66, _toDisplayString(_unref($t)("price")), 1),
                            _withDirectives(_createElementVNode("input", {
                              onKeydown: checkCurrency,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((event.value.trainer_pricing) = $event)),
                              currency: event.value.trainer_currency,
                              type: "text",
                              class: "capitalize text-black border w-full focus:outline-none rounded-l focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                              inputmode: "decimal"
                            }, null, 40, _hoisted_67), [
                              [_vModelText, event.value.trainer_pricing]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_68, _toDisplayString(_unref($t)("currency")), 1),
                            _withDirectives(_createElementVNode("select", {
                              id: "subscription",
                              class: "text-black border rounded-r w-32 focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600 uppercase",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((event.value.trainer_currency) = $event))
                            }, [
                              _createElementVNode("option", _hoisted_69, _toDisplayString(_unref($t)("please-select")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplate.value.countries.map(country => {
                        return country.currency;
                      }), (currency) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "uppercase",
                                  value: currency.toUpperCase(),
                                  key: currency
                                }, _toDisplayString(currency), 9, _hoisted_70))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, event.value.trainer_currency]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("label", _hoisted_72, _toDisplayString(_unref($t)("includes-tax")), 1),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                name: "vat",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((event.value.trainer_tax_status) = $event)),
                                value: "inc",
                                class: "rounded-full hover:cursor-pointer",
                                required: ""
                              }, null, 512), [
                                [_vModelRadio, event.value.trainer_tax_status]
                              ]),
                              _createElementVNode("label", _hoisted_75, _toDisplayString(_unref($t)("yes")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                name: "vat",
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((event.value.trainer_tax_status) = $event)),
                                value: "excl",
                                class: "rounded-full hover:cursor-pointer",
                                required: ""
                              }, null, 512), [
                                [_vModelRadio, event.value.trainer_tax_status]
                              ]),
                              _createElementVNode("label", _hoisted_77, _toDisplayString(_unref($t)("no")), 1)
                            ]),
                            (event.value.host_country !== 'united kingdom')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "vat",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((event.value.trainer_tax_status) = $event)),
                                    value: "none",
                                    class: "rounded-full hover:cursor-pointer",
                                    required: ""
                                  }, null, 512), [
                                    [_vModelRadio, event.value.trainer_tax_status]
                                  ]),
                                  _hoisted_79
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(RoleGuard, { roles: ['l4a-trainer', 'trainer-organisation'] }, {
                default: _withCtx(() => [
                  _createVNode(ListRowItem, {
                    title: _unref($t)('payment-link')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "payment",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((event.value.payment_link) = $event)),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          required: ""
                        }, null, 512), [
                          [_vModelText, event.value.payment_link]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('payment-gateway')
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "payment",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((event.value.payment_gateway) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        placeholder: _unref($t)('i-e-paypal'),
                        required: ""
                      }, null, 8, _hoisted_82), [
                        [_vModelText, event.value.payment_gateway]
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }),
              (selectedTemplate.value.delivery !== 'e-learning')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 5,
                    title: _unref($t)('minimum-attendees')
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "0",
                        step: "1",
                        id: "min_attendees",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((event.value.min_attendees) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                      }, null, 512), [
                        [_vModelText, event.value.min_attendees]
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (selectedTemplate.value.delivery !== 'e-learning')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 6,
                    title: _unref($t)('maximum-attendees')
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "0",
                        step: "1",
                        id: "max_attendees",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((event.value.max_attendees) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                      }, null, 512), [
                        [_vModelText, event.value.max_attendees]
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(RoleGuard, { roles: ['l4a-trainer', 'admin', 'courses-admin', 'trainer-organisation'] }, {
                default: _withCtx(() => [
                  _createVNode(ListRowItem, {
                    title: _unref($t)('go-live')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DatePicker, {
                        ref_key: "publish_at_datepicker",
                        ref: publish_at_datepicker,
                        onInternalModelChange: _cache[25] || (_cache[25] = e => setDate(e, 'publish_at')),
                        modelValue: event.value.publish_at,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((event.value.publish_at) = $event)),
                        required: "",
                        "min-date": new Date(),
                        "max-date": !_unref(isAsyncEvent) ? new Date(event.value.dates[0].event_date) : null,
                        format: "dd/MMM/yyyy"
                      }, null, 8, ["modelValue", "min-date", "max-date"])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }),
              (!asyncEventDelivery.includes(selectedTemplate.value.delivery))
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 7,
                    title: _unref($t)('registration-cut-off-date')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DatePicker, {
                        ref_key: "register_by_datepicker",
                        ref: register_by_datepicker,
                        onInternalModelChange: _cache[27] || (_cache[27] = e => setDate(e, 'register_by')),
                        modelValue: event.value.register_by,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((event.value.register_by) = $event)),
                        format: "dd/MMM/yyyy",
                        "min-date": new Date(event.value.publish_at),
                        "max-date": !_unref(isAsyncEvent) ? new Date(event.value.dates[0].event_date) : null,
                        "enable-time-picker": false
                      }, null, 8, ["modelValue", "min-date", "max-date"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_83, [
                _createVNode(TagSelector, {
                  onChange: setEventTags,
                  type: "event"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createVNode(DefaultButton, {
                id: "draft",
                type: "primary",
                "is-form-submit": true,
                loading: isDraftSaving.value,
                disabled: isDraftSaving.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)("save-as-draft")), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(RoleGuard, { roles: ['l4a-trainer', 'trainer-organisation'] }, {
                default: _withCtx(() => [
                  _createVNode(DefaultButton, {
                    id: "in review",
                    "is-form-submit": true,
                    type: "primary",
                    loading: isReviewSaving.value,
                    disabled: isReviewSaving.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)("submit-training-event-for-review")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
                default: _withCtx(() => [
                  _createVNode(DefaultButton, {
                    id: "published",
                    "is-form-submit": true,
                    type: "primary",
                    loading: isReviewSaving.value,
                    disabled: isReviewSaving.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)("publish-event")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              })
            ])
          ], 40, _hoisted_14)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})